module.exports = __webpack_public_path__ + "static/media/Nodeimage.a8b1645f.png";